import React, { useEffect, useState, useLayoutEffect } from 'react';
import {
	Container,
	Row,
	Col,
	Button,
	Table,
	Form,
	Figure,
	Tabs,
	Tab,
	Modal,
	InputGroup,
	Pagination,
} from "react-bootstrap";
import { 
	RiUploadLine ,
	RiDeleteBinLine,
	RiCloseLine,
	RiUpload2Line,
} from "react-icons/ri";
import Config from '../common/config.js';
import pushInput from '../common/PushInput.js';
import pushStat from '../common/PushStat.js';
import {CommonUI} from '../common/commonUI.js';


const PopupSendFailList = (opt) => {
	//Config.log("PopupSearchPushTarget opt-->");
	//Config.log(opt);

	const [countReal, setCountReal] = useState(0);
	const [userList, setUserList] = useState([]);
	const [pageItems, setPageItems] = useState([]);

	useEffect( () => {
		Config.log("refresh 1");
		reqList(1);
	}, []);


	const selfClose = function() {
		opt.close(false);
	};

	const goPage = (pageNum) => {
		reqList(pageNum);
	}

	const reqList = async (pg) => {
		Config.log(opt.data);
		let sendData = {};
		sendData["push_seq"] = opt.data.seq;
		sendData["status"] = "F";
		const resp =  pushStat.getLogList({data:sendData, callback:function(json) {
			setUserList(json.list);
			setCountReal(json.countReal);
			let items2 = CommonUI.pagenationItems({currPage:pg, totalRecords:json.count, eventHandler:goPage})
			setPageItems(items2);
		}});
		Config.log("getPushTargetList response=>");
		//resp.then( (data) => setUserList(data));
	}

	const retrySend = () => {
		if(window.confirm("발송 실패한 메시지를 재발송하시겠습니까?")) {
			if(opt.data.message_type == "ad") {
				if(check_reserve_time() == false) return;
			}
			Config.log(opt.data);
			let sendData = {};
			sendData["push_seq"] = opt.data.seq;
			sendData["status"] = "F";
			const resp =  pushInput.retryPushSend({data:sendData, callback:function(json) {
				if(json) {
					alert("푸시 재발송을 성공했습니다. \n 집계시점에 따라 성공건수와 실패건수의 차이가 있을 수 있습니다.");
					selfClose();
				}
				else {
					alert("재발송에 실패하였습니다. 다시시도해주세요.");
				}

			}});
	
		}
	}

	function check_reserve_time() {
		let rtn = true;
		let hour_v = getCurrentTime();
		if(hour_v >= "20:00" || hour_v <= "08:00") {
			rtn = false;
		}
		if(rtn == false) {
			alert('20:00 ~ 08:00 광고 발송 제한 시간입니다.');
		}
		return rtn;
	}

	function getCurrentTime() {
		const now = new Date();
		const hours = String(now.getHours()).padStart(2, '0'); // 시간
		const minutes = String(now.getMinutes()).padStart(2, '0'); // 분
		//const seconds = String(now.getSeconds()).padStart(2, '0'); // 초
	
		return `${hours}:${minutes}`;
	}

	const eventHandle = (ev: React.ChangeEvent<HTMLInputElement>) => {
		let evo = ev.currentTarget;
		let act_v = evo.getAttribute("data-act");
		console.log("act = " + act_v);
		if(act_v == "select") {
			var key = evo.getAttribute("data-index");
			Config.log("key=" + key);
			let uItem = userList[key];
			if(uItem.contentList) {
				let data = uItem.contentList;
				const user_ids = data.map(item => item.userId).join(', ');
				Config.log(user_ids);
				//opt.callback({list:user_ids, count:data.length});
				selfClose();
			}
		}
		else if(act_v == "close") {
			//isShow = false;
			selfClose();
		}
		else if(act_v == "downloadExcel") {
			let fm = document.querySelector("#frmPopupFaileList");
			if(fm) {
				fm.action = Config.host_api + "/push/downloadExcelFailList";
				fm.submit();
			}
		}
	};

	return (
		<Modal show={opt.isShow} onHide={selfClose} centered className="" size="lg">
			<Modal.Header closeButton>
			<Modal.Title>발송 실패 정보</Modal.Title>
			</Modal.Header>
				<Modal.Body>
					<form name="frmPopupFaileList" id="frmPopupFaileList" method="post">
						<input type="hidden" name="push_seq" id="push_seq" value={opt.data.seq}/>
						<input type="hidden" name="status" id="status" value="F" />
					</form>
					<div className="table__view">
						<Table bordered responsive className="table__view">
							<tbody>
								<tr>
									<th scope='row'>발송(예약)일시</th>
									<td className="text-start">{(opt.data.reserve_date_str=="")?opt.data.reg_date_str:opt.data.reserve_date_str}</td>
								</tr>
								<tr>
									<th scope='row'>앱 이름(앱 ID)</th>
									<td className="text-start">{opt.data.app_name}</td>
								</tr>
								<tr>
									<th scope='row'>메시지</th>
									<td className="text-start">{opt.data.title}</td>
								</tr>
								<tr>
									<th scope='row'>발송 성공</th>
									<td className="text-start">{opt.data.count_success.toLocaleString()}/{opt.data.count_total.toLocaleString()}</td>
								</tr>
								<tr>
									<th scope='row'>발송 실패</th>
									<td className="text-start">{opt.data.count_fail.toLocaleString()}/{opt.data.count_total.toLocaleString()}</td>
								</tr>
							</tbody>
						</Table>
					</div>
					<div className="mt-2 text-end">
						<Button variant="dark" size="sm" data-act="downloadExcel" onClick={eventHandle}>리스트 다운로드</Button>
					</div>
					<div className="table__wrap mt-2">
						<Table bordered responsive>
							<thead>
								<tr>
									<th scope='col'>No</th>
									<th scope='col'>ID</th>
									<th scope='col'>성명</th>
									<th scope='col'>계정</th>
									<th scope='col'>플랫폼</th>
									<th scope='col'>실패 사유</th>
								</tr>
							</thead>
							<tbody>
								{
									userList.length > 0 ?
									userList.map( (item, index) =>
										<tr>
											<td>{index + 1}</td>
											<td>{item.user_id}</td>
											<td>{item.user_name}</td>
											<td>{item.email}</td>
											<td>{item.device_type}</td>
											<td className='text-start'>{(item.send_result == null)?"not found":item.send_result}</td>
										</tr>
									)
									: (<tr><td colSpan={5}>데이터가 없습니다.</td></tr>)
								}

							</tbody>
						</Table>
						<div className="table__pagination">
							<Pagination>{pageItems}</Pagination>
						</div>
					</div>
				</Modal.Body>
			<Modal.Footer>
			{
				(countReal > 0)?
				<Button variant="primary" onClick={() => retrySend()}>재발송</Button>
				:""
			}
			<Button variant="secondary" onClick={() => selfClose()}>닫기</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default PopupSendFailList;
